/**
 * Created by JIocb on 02.07.2017.
 */
namespace Factive.Game {
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import EventBus = Factive.Core.EventBus;
    import Signal = Factive.Core.Signal.Signal;
    import StorageManager = Factive.Core.StorageManager;
    import StorageManagerConstants = Factive.Core.StorageManagerConstants;
    import ISoundManager = Factive.Core.ISoundManager;
    export class ControlsView {

        private _lm:LocalizationManager;
        private _dc: Factive.Core.DependenciesContainer;
        private _sceneArmature: dragonBones.Armature;
        private _rollBtn: DragonBonesButton;
        private _assetScale:number;
        private _eb: EventBus;
        private _buttonById: any = {};
        public signal:Signal;

        constructor(dc: DependenciesContainer)
        {
            this._dc = dc;
            this._lm = this._dc.get("LocalizationManager");
            this._assetScale = this._dc.get("AssetScale");
            this._eb = this._dc.get("EventBus");

            this.signal = new Signal();
        }

        public initialize(sceneArmature:dragonBones.Armature,aspectRatio:string):void
        {
            this._sceneArmature = sceneArmature;

            var btnArmature = this._sceneArmature.getSlot("RollButton").childArmature;
            this._rollBtn = new DragonBonesButton(btnArmature,this._dc);
            this._rollBtn.addPressListener(this.handlePress, this);
            this._rollBtn.addLabel(this._lm.getText("roll")+"3", 0, 0, <PIXI.TextStyle>{
                fontFamily: 'Medium',
                fontSize: ((aspectRatio == "landscape" )? 12 * this._assetScale:11 * this._assetScale) ,
                fill: '#FFFFFF',
                align: "center"
            });


            var buttons:Array<string>;
            if(aspectRatio == "landscape") {
                buttons = ["BtnSoundOn", "BtnSoundOff", 'BtnHelp', 'BtnQuit', "BtnUndo"];
            }
            else {
                buttons = ["BtnSettings", "BtnUndo"];
            }
            for (var i = 0; i < buttons.length; i++) {
                var btnSlot = this._sceneArmature.getSlot(buttons[i])
                if(btnSlot)
                {
                    btnArmature = btnSlot.childArmature;
                    var btn = new DragonBonesButton(btnArmature,this._dc);
                    this._buttonById[buttons[i]] = btn;
                    btn.addPressListener(this["handlePress" + buttons[i]], this)
                }
            }
            this.checkSoundBtn();
        };

        protected handlePress(): void
        {
            this.signal.dispatch("press_roll");
        };

        protected handlePressBtnSettings(): void
        {
            this.signal.dispatch("press_settings");
        };

        protected handlePressBtnSoundOn(): void
        {
            this.signal.dispatch("press_sound_on");
            this.changeSound();
        };

        protected handlePressBtnSoundOff(): void {
            this.signal.dispatch("press_sound_off");
            this.changeSound();
        };

        protected changeSound(): void {

            let ls:StorageManager = <StorageManager>this._dc.get("StorageManager");
            let mute:boolean = ls.loadData(StorageManagerConstants.MUTE_SOUNDS) == "1";
            mute = !mute;

            ls.saveData(StorageManagerConstants.MUTE_SOUNDS,mute?"1":"0");

            let sm:ISoundManager = <ISoundManager>this._dc.get("SoundManager");
            sm.mute(mute);

            //let sm:ISoundManager = <ISoundManager>this._dc.get("SoundManager");
            //sm.playSound(SoundConstants.MUSIC_LOOP, true);

            this.checkSoundBtn();
        };
        protected checkSoundBtn(): void
        {
            let ls:StorageManager = <StorageManager>this._dc.get("StorageManager");
            let mute:boolean = ls.loadData(StorageManagerConstants.MUTE_SOUNDS) == "1";

            if(this._sceneArmature.getSlot("BtnSoundOn"))
                this._sceneArmature.getSlot("BtnSoundOn").childArmature.display.visible = !mute;

            if(this._sceneArmature.getSlot("BtnSoundOff"))
                this._sceneArmature.getSlot("BtnSoundOff").childArmature.display.visible = mute;
        };

        protected handlePressBtnHelp(): void {
            this.signal.dispatch("press_help")
        };

        protected handlePressBtnQuit(): void
        {
            this.signal.dispatch("press_quit")
        };

        protected handlePressBtnUndo(): void
        {
            this.signal.dispatch("press_undo")
        };

        public destroy():void
        {
            this._sceneArmature = null;

            var keys = Object.keys(this._buttonById);
            var l:number = keys.length;
            for(var i:number= 0; i < l; i++)
            {
                var btn:DragonBonesButton = this._buttonById[keys[i]];
                btn.removePressListener(this["handlePress"+keys[i]],this)
                btn.destroy();
            }

            this._rollBtn.removePressListener(this.handlePress,this);
            this._rollBtn.destroy();
            this._rollBtn = null;

            this.signal.removeAll();
            this.signal = null;
            this._buttonById = null;
            this._dc = null;
            this._lm = null;
            this._eb = null;
        };

        public undoEnableInput(b: boolean)
        {
            this._buttonById["BtnUndo"].enableInput(b);
        };

        public rollEnableInput(b: boolean) {
            this._rollBtn.enableInput(b);

        };

        public rollAddLabel(text: string) {
            this._rollBtn.addLabel(text);

        };

    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/View/ControlsView.ts